import Vue from 'vue';
import { BootstrapVue, ToastPlugin } from 'bootstrap-vue';

Vue.mixin({
  methods: {
    /**
     * Shows a toast
     * @param {*} msg
     * @param {*} title
     * @param {*} variant
     * @param {*} noAutoHide
     */
    showToast(message, title, variant = 'danger', noAutoHide = true) {
      this.$store.dispatch('toast/showToast', {
        title,
        message,
        variant,
        noAutoHide,
      });
    },
    showConfirmPrompt(callback, msg = 'Are you sure you want to proceed?', okTitle = 'YES', cancelTitle = 'Cancel', title = null) {
      this.$bvModal
        .msgBoxConfirm(msg, {
          title: title,
          okTitle,
          cancelTitle,
        })
        .then(userResp => {
          if (userResp) callback();
        });
    },
    showErrorMessage(message, status_code) {
      this.showToast(message, status_code + ' Error', 'danger', false);
    },
  },
});

Vue.use(BootstrapVue);
Vue.use(ToastPlugin);
//Vue.use(BootstrapVueIcons);
